export default __webpack_public_path__ + "static/media/discord2.3849aaee.png";